import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { HttpService } from '../http.service';
import { defaultCompany } from '../util/default-company';

@Injectable({
  providedIn: 'root'
})
export class IsLoginGuard  {
  constructor(private http: HttpService) {

  }
  
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {    
  
      return new Promise(async (resolve, reject) => {
        const access = this.http.getAccess();
        if (this.http.isViewingUser) {
          const page = state.url.split('?')[0].split('/').filter(Boolean).slice(2).join('/');
          if (page && page !== 'unauthorized' && !this.http.viewAsReportPages.includes(page)) {
            this.http.notify('Read-only user view supports the accounting reports. Exit user view for other pages.');
            return resolve(false);
          }
        }

        // Collection pages inherit the dashboard/credit permissions of the destination company.
        const creditCollection = state.url.split('?')[0].match(/^\/lo\/([^/]+)\/credit-collection\/?$/);
        if (creditCollection) {
          const companies: any = this.http.getCompany()?.length ? this.http.getCompany() : await this.http.setCompany();
          const target = companies?.find(c => c.uuid === creditCollection[1]);
          if (!access?.token || !target) {
            this.http.navigate(['/lr']);
            return resolve(false);
          }
          const grants: any = await this.http.post('/admin/user/permission/hidden', { company_uuid: target.uuid, consolidated_wallet_context: false });
          const isConsolidated = new URLSearchParams(state.url.split('?')[1] || '').get('scope') === 'consolidated';
          const required = isConsolidated ? ['consolidated-dashboard'] : ['dashboard', 'player-credit', 'player-credit-report'];
          if (!required.some(key => grants?.[key] == 1)) {
            this.http.navigate(['/lo', target.uuid, 'unauthorized']);
            return resolve(false);
          }
          return resolve(true);
        }

        // Check the destination company's page and wallet permissions before its resolver runs.
        const consolidated = state.url.split('?')[0].match(/^\/lo\/([^/]+)\/(consolidated-wallet|consolidated-phone-report|intercompany-adjustment|risk-review)\/?$/);
        if (consolidated) {
          const companies: any = this.http.getCompany()?.length ? this.http.getCompany() : await this.http.setCompany();
          const target = companies?.find(c => c.uuid === consolidated[1]);
          if (!access?.token || !target) {
            this.http.navigate(['/lr']);
            return resolve(false);
          }
          const grants: any = await this.http.post('/admin/user/permission/hidden', {
            company_uuid: target.uuid, consolidated_wallet_context: ['consolidated-wallet', 'consolidated-phone-report'].includes(consolidated[2])
          });
          const allowedAction = consolidated[2] === 'risk-review' || (consolidated[2] === 'intercompany-adjustment' ? ['wallet-adjustment'] : ['manual-topup-withdraw', 'auto-topup-withdraw', 'wallet-topup-withdraw']).some(key => grants?.[key] == 1);
          if (grants?.[consolidated[2] === 'consolidated-phone-report' ? 'consolidated-wallet' : consolidated[2]] != 1 || !allowedAction) {
            this.http.navigate(['/lo', target.uuid, 'unauthorized']);
            return resolve(false);
          }
          return resolve(true);
        }

        let company = this.http.getStaticSelectedCompany();

        if(!company) {
          company = await this.http.setCompany();
          const initial = defaultCompany(company, state.url.split('?')[0].match(/^\/lo\/([^/]+)/)?.[1]);
          if (!initial) { this.http.navigate(['/lr']); return resolve(false); }
          this.http.setSelectedCompany(initial.uuid);
          company = this.http.getStaticSelectedCompany();
        }

        let hidden = await this.http.post('/admin/user/permission/hidden', { consolidated_wallet_context: false });

        let paths = Object.keys(hidden);
        paths.push("unauthorized");
        paths.push("page-not-found");
        paths.push("document");
        paths.push("reset-password");
        let path = paths.find(path => state.url.includes(path));

        if (!access || !access.token) {
          this.http.navigate(['/lr'])
          return resolve(false);
        } else if (state.url && state.url != "/lo" && paths.length > 0 && company && !path) {
          this.http.navigate(['/lo', company, 'unauthorized'])
          return resolve(false);
        }

        return resolve(true);
      });
  }
  
}
